const CommunicationTypes = {
  Log: 1,
  Comment: 2
};

Object.freeze(CommunicationTypes);

export default CommunicationTypes;